var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:{ clickable: _vm.column.orderable !== false },on:{"click":function($event){_vm.column.orderable !== false ? _vm.$emit('click', _vm.column) : null}}},[_vm._v("\n  "+_vm._s(_vm.getNameForColumn(_vm.column))+" \n  "),(_vm.$route.query.order_by == _vm.column.key && _vm.column.orderable !== false)?_c('i',{staticClass:"fas",class:_vm.$route.query.order_direction == 'asc'
        ? 'fa-sort-amount-up-alt'
        : 'fa-sort-amount-down-alt'}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }